import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';

// Immoweb and LogicImmo are not supported portals for the moment

const portalMap: Record<string, Portal> = {
    immonet: Portal.Immonet,
    immowelt: Portal.ImmoWelt,
    'private-seloger': Portal.SeLoger,
    PRIVATE_SELOGER: Portal.SeLoger,
};

export const mapTenantToPortal = (tenant?: string): Portal | undefined => {
    return tenant ? portalMap[tenant] : undefined;
};
